module.exports = __webpack_public_path__ + "static/media/csci100-website.1d25c63d.png";